// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Register-root-wPhWS {
	padding-left: 20px;
	padding-right: 20px;
}

.Register-container-Q81pW {
	margin: 0 auto;
	padding: 30px 0 40px;
	max-width: 380px;
}

.Register-lineThrough-rD3CP {
	position: relative;
	z-index: 1;
	display: block;
	margin: 12px 0px 20px;
	width: 100%;
	text-align: center;
	font-size: 14px;
}

.Register-horizontalLineThrough-Ws_su {
	position: relative;
	z-index: 1;
	display: block;
	margin: 15px 0px;
	width: 100%;
	color: var(--primary-border);
	text-align: center;
	font-size: 14px;
}

.Register-formGroup-Ortl1 {
	margin-bottom: 6px;
}

.Register-formSection-Zfiml {
	overflow: hidden;
}

.Register-noPadding-oIEu7 {
	padding: 0px !important;
}

.Register-textAlignRight-s8GEa {
	text-align: right;
}

.Register-textAlignLeft-QrBtp {
	text-align: left;
}

.Register-modalCaptionLink-OLlu3 {
	color: var(--primary-link-foreground);
	cursor: pointer;
}

.Register-modalCaptionLinkLarge-AmEcp {
	font-size: 16px;
	line-height: 32px;
}

.Register-modalCaptionLink-OLlu3,
.Register-modalCaptionLink-OLlu3:hover,
.Register-modalCaptionLink-OLlu3:focus,
.Register-modalCaptionLink-OLlu3:active {
	color: var(--primary-link-foreground);
	font-size: 14px;
	text-decoration: underline;
}

.Register-button-V6D5U {
	display: block;
	width: 100%;
	text-align: center;
	text-decoration: none !important;
}

.Register-captionText-gprNW {
	font-size: 16px;
	color: var(--primary-foreground);
	margin: 15px 0px;
}

.Register-linkText-zc05E {
	font-size: 14px;
	line-height: 18px;
	font-weight: 500;
	display: grid;
	grid-template-columns: auto auto;
	grid-gap: 6px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	margin-bottom: 0px;
	margin-top: 20px;
}

.Register-linetext-byS_3 {
	position: relative;
	display: inline-block;
}

.Register-linetext-byS_3::before {
	content: '';
	position: absolute;
	top: 9px;
	left: -30px;
	width: 26px;
	height: 1px;
	background-color: var(--primary-foreground);
}

.Register-linetext-byS_3::after {
	content: '';
	position: absolute;
	top: 9px;
	right: -30px;
	width: 26px;
	height: 1px;
	background-color: var(--primary-foreground);
}

.Register-loginHeading-H0l2L {
	font-size: 18px;
	text-align: center;
	margin: 0 0 22px;
}

@media screen and (max-width: 1200px) {
	.Register-container-Q81pW {
		margin: 0 auto;
		padding: 100px 0 40px;
		max-width: 380px;
	}
}`, "",{"version":3,"sources":["webpack://./src/routes/register/Register.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,qBAAqB;CACrB,WAAW;CACX,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,gBAAgB;CAChB,WAAW;CACX,4BAA4B;CAC5B,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qCAAqC;CACrC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;;;;CAIC,qCAAqC;CACrC,eAAe;CACf,0BAA0B;AAC3B;;AAEA;CACC,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,aAAa;CACb,gCAAgC;CAChC,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,WAAW;CACX,WAAW;CACX,2CAA2C;AAC5C;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,WAAW;CACX,2CAA2C;AAC5C;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC;EACC,cAAc;EACd,qBAAqB;EACrB,gBAAgB;CACjB;AACD","sourcesContent":[".root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 30px 0 40px;\n\tmax-width: 380px;\n}\n\n.lineThrough {\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: block;\n\tmargin: 12px 0px 20px;\n\twidth: 100%;\n\ttext-align: center;\n\tfont-size: 14px;\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: block;\n\tmargin: 15px 0px;\n\twidth: 100%;\n\tcolor: var(--primary-border);\n\ttext-align: center;\n\tfont-size: 14px;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.formSection {\n\toverflow: hidden;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textAlignRight {\n\ttext-align: right;\n}\n\n.textAlignLeft {\n\ttext-align: left;\n}\n\n.modalCaptionLink {\n\tcolor: var(--primary-link-foreground);\n\tcursor: pointer;\n}\n\n.modalCaptionLinkLarge {\n\tfont-size: 16px;\n\tline-height: 32px;\n}\n\n.modalCaptionLink,\n.modalCaptionLink:hover,\n.modalCaptionLink:focus,\n.modalCaptionLink:active {\n\tcolor: var(--primary-link-foreground);\n\tfont-size: 14px;\n\ttext-decoration: underline;\n}\n\n.button {\n\tdisplay: block;\n\twidth: 100%;\n\ttext-align: center;\n\ttext-decoration: none !important;\n}\n\n.captionText {\n\tfont-size: 16px;\n\tcolor: var(--primary-foreground);\n\tmargin: 15px 0px;\n}\n\n.linkText {\n\tfont-size: 14px;\n\tline-height: 18px;\n\tfont-weight: 500;\n\tdisplay: grid;\n\tgrid-template-columns: auto auto;\n\tgrid-gap: 6px;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-bottom: 0px;\n\tmargin-top: 20px;\n}\n\n.linetext {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n.linetext::before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 9px;\n\tleft: -30px;\n\twidth: 26px;\n\theight: 1px;\n\tbackground-color: var(--primary-foreground);\n}\n\n.linetext::after {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 9px;\n\tright: -30px;\n\twidth: 26px;\n\theight: 1px;\n\tbackground-color: var(--primary-foreground);\n}\n\n.loginHeading {\n\tfont-size: 18px;\n\ttext-align: center;\n\tmargin: 0 0 22px;\n}\n\n@media screen and (max-width: 1200px) {\n\t.container {\n\t\tmargin: 0 auto;\n\t\tpadding: 100px 0 40px;\n\t\tmax-width: 380px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Register-root-wPhWS`,
	"container": `Register-container-Q81pW`,
	"lineThrough": `Register-lineThrough-rD3CP`,
	"horizontalLineThrough": `Register-horizontalLineThrough-Ws_su`,
	"formGroup": `Register-formGroup-Ortl1`,
	"formSection": `Register-formSection-Zfiml`,
	"noPadding": `Register-noPadding-oIEu7`,
	"textAlignRight": `Register-textAlignRight-s8GEa`,
	"textAlignLeft": `Register-textAlignLeft-QrBtp`,
	"modalCaptionLink": `Register-modalCaptionLink-OLlu3`,
	"modalCaptionLinkLarge": `Register-modalCaptionLinkLarge-AmEcp`,
	"button": `Register-button-V6D5U`,
	"captionText": `Register-captionText-gprNW`,
	"linkText": `Register-linkText-zc05E`,
	"linetext": `Register-linetext-byS_3`,
	"loginHeading": `Register-loginHeading-H0l2L`
};
module.exports = ___CSS_LOADER_EXPORT___;
